<template>
  <div class="helpdesk">
    <h1 class="titulo-card fs-4">Helpdesk</h1>
    <div class="form-group card-principal">
      <div class="d-flex justify-content-between">
        <div class="input-group mb-3">
          <button v-on:click="modalNovoTicketAbreHandle()" class="btn btn-success">
            <font-awesome-icon :icon="['fas', 'magic']" fixed-width class="me-1"/>Novo ticket
          </button>
        </div>

        <div class="input-group mb-3">
          <input
              v-on:keyup.enter="carregaTickets()"
              type="text"
              class="form-control"
              placeholder="Pesquisar"
              aria-label="Pesquisar"
              aria-describedby="button-addon2">
          <button v-on:click="carregaTickets()" class="btn btn-outline-secondary" type="button" id="button-addon2">
            <font-awesome-icon :icon="['fas', 'search']" fixed-width class="me-1"/>
          </button>
        </div>
      </div>
      <div class="d-flex">
        <div class="row m-0 w-100">
          <div class="col-auto small lista-grupos">
            <table class="table table-sm-pc table-striped table-hover" style="width: 150px;">
              <tbody>
                <tr v-on:click="exibeMeusTickets()"
                    v-bind:class="classeGrupoSelecionado('teMeusTickets', 0)"
                    class="cursor-pointer item-grupo">
                  <td width="25">
                    <font-awesome-icon :icon="['fas', 'user-tag']"/>
                  </td>
                  <td>Meus tickets</td>
                  <td width="15">
                    <span class="badge rounded-pill bg-primary">
                      {{contadores.meus_tickets}}
                    </span>
                  </td>
                </tr>
                <tr v-on:click="exibeTicketsDoMeuGrupo()"
                    v-bind:class="classeGrupoSelecionado('teDoMeuGrupo', 0)"
                    class="cursor-pointer item-grupo">
                  <td>
                    <font-awesome-icon :icon="['fas', 'user-friends']"/>
                  </td>
                  <td>Do meu grupo</td>
                  <td>
                    <span class="badge rounded-pill bg-info">
                      {{contadores.tickets_do_meu_grupo}}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-sm-pc table-striped table-hover" style="width: 150px;">
              <tbody>
                <tr v-for="grupo in listaGrupos"
                    :key="grupo.id"
                    v-on:click="exibeTicketsDoGrupo(grupo.id)"
                    v-bind:class="classeGrupoSelecionado('teGrupo', grupo.id)"
                    class="cursor-pointer item-grupo">
                  <td width="25">
                    <font-awesome-icon :icon="['fas', 'users']"/>
                  </td>
                  <td>{{grupo.descricao}}</td>
                  <td width="15">
                    <span class="badge rounded-pill bg-secondary">
                      {{contadorGrupo(grupo.id)}}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>

            <table class="table table-sm-pc table-striped table-hover" style="width: 150px;">
              <tbody>
                <tr v-on:click="exibeTicketsAbertos()"
                    v-bind:class="classeGrupoSelecionado('teAbertos', 0)"
                    class="cursor-pointer item-grupo">
                  <td width="25"><font-awesome-icon :icon="['fas', 'tags']"/></td>
                  <td>Abertos</td>
                  <td width="15">
                    <span class="badge rounded-pill bg-secondary">
                      {{contadores.tickets_abertos}}
                    </span>
                  </td>
                </tr>
                <tr v-on:click="exibeTicketsAguardando()"
                    v-bind:class="classeGrupoSelecionado('teAguardando', 0)"
                    class="cursor-pointer item-grupo">
                  <td><font-awesome-icon :icon="['fas', 'tags']"/></td>
                  <td>Aguardando</td>
                  <td>
                    <span class="badge rounded-pill bg-secondary">
                      {{contadores.tickets_aguardando}}
                    </span>
                  </td>
                </tr>
                <tr v-on:click="exibeTicketsAtrasados()"
                    v-bind:class="classeGrupoSelecionado('teAtrasados', 0)"
                    class="cursor-pointer item-grupo">
                  <td><font-awesome-icon :icon="['fas', 'stopwatch']"/></td>
                  <td>Atrasados</td>
                  <td>
                    <span v-bind:class="{'bg-secondary': !contadores.tickets_atrasados, 'bg-warning': contadores.tickets_atrasados}" class="badge rounded-pill">
                      {{contadores.tickets_atrasados}}
                    </span>
                  </td>
                </tr>
                <tr v-on:click="exibeTicketsEncerrados()"
                    v-bind:class="classeGrupoSelecionado('teEncerrados', 0)"
                    class="cursor-pointer item-grupo">
                  <td><font-awesome-icon :icon="['fas', 'check-double']"/></td>
                  <td>Encerrados</td>
                  <td>
                    <span class="badge rounded-pill bg-secondary">
                      {{contadores.tickets_encerrados}}
                    </span>
                  </td>
                </tr>
                <tr v-on:click="exibeHistoricoTickets()"
                    v-bind:class="classeGrupoSelecionado('teHistorico', 0)"
                    class="cursor-pointer item-grupo">
                  <td><font-awesome-icon :icon="['fas', 'history']"/></td>
                  <td>Histórico</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col">

            <!-- TABELA 1 -->
            <table class="table table-sm-pc table-striped table-hover tabela-tickets small">
              <thead>
                <tr>
                  <th width="35" class="text-center">
                    <div class="form-check mb-0">
                      <label class="form-check-label">
                        <input type="checkbox" class="form-check-input cursor-pointer mt-2">
                      </label>
                    </div>
                  </th>
                  <th>Cliente</th>
                  <th>Ticket</th>
                  <th width="85">Importância</th>
                  <th width="85">Status</th>
                </tr>
                </thead>
                <tbody>
                  <tr v-for="ticket in tickets" :key="ticket.id" class="item-ticket">
                    <td class="text-center" scope="row">
                      <div class="form-check mb-0">
                        <label class="form-check-label">
                          <input v-model="ticket._checked" type="checkbox" class="form-check-input cursor-pointer mt-2">
                        </label>
                      </div>
                    </td>
                    <td v-on:click="visualizaTicket(ticket)" class="cursor-pointer">
                      <div class="row g-1">
                        <div class="col-auto">
                          <avatar :username="ticket.identificacao" :size="36" :lighten="100"></avatar>
                        </div>
                        <div class="col">
                          <p class="mb-0 fw-bold">
                            {{ticket.identificacao}}
                          </p>
                          <p v-if="ticket.cliente_id" class="mb-0 fst-italic text-secondary">
                            {{nomeCliente(ticket.cliente_id)}}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td v-on:click="visualizaTicket(ticket)" class="cursor-pointer">
                      <span class="fw-bold">{{ticket.descricao_curta}} - </span>
                      <span class="fst-italic">{{ticket.descricao_longa}}</span>
                    </td>
                    <td v-on:click="visualizaTicket(ticket)" class="cursor-pointer">{{formataAberto(ticket)}}</td>
                    <td v-on:click="visualizaTicket(ticket)" class="cursor-pointer">
                      <span v-if="ticket.estagio === 'etCriacao'" class="badge rounded-pill bg-warning">
                        Em criação
                      </span>
                      <span v-if="ticket.estagio === 'etAberto' && !ticket.atendimento_iniciado" class="badge rounded-pill bg-warning">
                        Novo
                      </span>
                      <span v-if="ticket.estagio === 'etAberto' && ticket.atendimento_iniciado" class="badge rounded-pill bg-primary">
                        Em atendimento
                      </span>
                      <span v-if="ticket.estagio === 'etEncerrado'" class="badge rounded-pill bg-secondary">
                        Encerrado
                      </span>
                      <span v-if="ticket._atrasado === true" class="badge rounded-pill bg-danger">
                        Atrasado
                      </span>
                    </td>
                  </tr>
                </tbody>
            </table>
            <!-- TABELA 1 -->

            <Paginador v-model="paginador" @change-paginacao="onChangePaginacao"/>
          </div>
        </div>

      </div>
    </div>

    <!-- modal-novo-ticket -->
    <!-- Button trigger modal -->
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#modal-novo-ticket" id="btn-modal-novo-ticket-abre">
      Launch
    </button>

    <!-- Modal -->
    <div class="modal fade" id="modal-novo-ticket" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-fullscreen-margin" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <font-awesome-icon :icon="['fas', 'plus']" fixed-width/>
              Novo ticket
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12 mb-2">
                <label>Quem solicitou o chamado? (não precisa ser o assinante)</label>
                <input v-model="modalNovoTicket.form.identificacao" type="text" maxlength="50" class="form-control">
              </div>

              <div class="col-12 mb-2">
                <label>Contato para retornar se necessário (telefone, email, instagram, facebook, etc)</label>
                <input v-model="modalNovoTicket.form.contato" type="text" maxlength="32" class="form-control">
              </div>

              <div class="col-12 mb-2">
                <label>Descrição curta (apenas um título descritivo)</label>
                <input v-model="modalNovoTicket.form.descricaoCurta" type="text" maxlength="64" class="form-control">
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal" id="btn-modal-novo-ticket-fecha">Cancelar</button>
            <button type="button"
                v-on:click="modalNovoTicketCadastrarHandle()"
                v-bind:disabled="!modalNovoTicketPodeSalvar()"
                class="btn btn-success">
              Abrir novo chamado
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- modal-novo-ticket -->
  </div>
</template>

<script>
import Paginador from '@/components/Paginador.vue'
import api from '@/modules/api'
import dialogo from '@/modules/dialogo'
import loading from '@/modules/loading'
import clone from '@/modules/clone'
import model from '@/model'
import store from '@/store'
import Avatar from 'vue-avatar'
// import pesquisaCliente from '@/modules/pesquisa-cliente'

export default {
  name: 'Helpdesk',

  components: {
    Paginador,
    Avatar,
  },

  data() {
    return {
      /** @type {model.paginador} */
      paginador: clone(model.paginador),
      meuID: 0,
      meuGrupoID: 0,
      tipoExibicao: '', //teMeusTickets, teDoMeuGrupo, teGrupo, teAbertos, teAguardando, teAtrasados, teEncerrados, teHistorico
      grupoExibicao: 0,
      tickets: [],
      listaGrupos: [],
      listaOperadores: [],
      clientes: [],
      intervaloContadores: undefined,
      contadores: {
        meus_tickets: 0,
        meus_tickets_atrasados: 0,
        tickets_do_meu_grupo: 0,
        tickets_abertos: 0,
        tickets_aguardando: 0,
        tickets_atrasados: 0,
        tickets_encerrados: 0,
        grupos: [],
      },
      modalNovoTicket: {
        form: {
          identificacao: '',
          contato: '',
          descricaoCurta: '',
        }
      }
    }
  },

  methods: {
    carregaTickets() {
      loading(true);

      api.get(`/helpdesk/tickets?${this.paginador.requestParams}&${this.listaParams}`).then(res => {
        loading(false);
        this.tickets = res.data.itens;
        this.clientes = res.data.clientes;
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    carregaMeuID() {
      const userData = store.getters['auth/getUserData'];

      this.meuID = userData.funcionario_id;
      this.meuGrupoID = userData.helpdesk_grupo_id;
    },


    carregaGrupos() {
      api.get(`/helpdesk/grupos?paginacao.porPagina=-1&orderBy[prioridade]=desc`).then(res => {
        this.listaGrupos = res.data.itens;
      }).catch(() => {
        setTimeout(() => {
          this.carregaGrupos();
        }, 1000);
      });
    },

    carregaOperadores() {
      api.get(`/usuarios?paginacao.porPagina=-1&orderBy[nome]=desc`).then(res => {
        this.listaOperadores = res.data.itens;
      }).catch(() => {
        setTimeout(() => {
          this.carregaOperadores();
        }, 1000);
      });
    },

    onChangePaginacao() {
      this.carregaTickets();
    },

    //TODO: tornar esta função como global
    /**
     * @param {Number} numero
     * @param {Number} zeros
     * @returns {string} Strins com "zeros" à esquerda do número informado
     **/
    strZero(numero, zeros){
        return Array(zeros-String(numero).length+1).join('0') + numero;
    },

    // TODO: tornar esta função como global
    /**
     * @param {Date} data
     * @returns {string} Data no formato YYYY-MM-DD
     **/
    dateTimeToMySQLDateTimeStr(data) {
      const dia = this.strZero(data.getDate(), 2);
      const mes = this.strZero(data.getMonth()+1, 2);
      const hora = this.strZero(data.getHours(), 2);
      const minuto = this.strZero(data.getMinutes(), 2);
      const segundo = this.strZero(data.getSeconds(), 2);

      return `${data.getFullYear()}-${mes}-${dia} ${hora}:${minuto}:${segundo}`;
    },

    exibeMeusTickets() {
      this.tipoExibicao = 'teMeusTickets';
      this.grupoExibicao = 0;
      this.listaParams = `estagio[in]=etCriacao,etAberto&operador_id=${this.meuID}`;
      this.listaTickets();
    },

    exibeTicketsDoMeuGrupo() {
      this.tipoExibicao = 'teDoMeuGrupo';
      this.grupoExibicao = 0;
      this.listaParams = `estagio[in]=etCriacao,etAberto&grupo_id=${this.meuGrupoID}`;
      this.listaTickets();
    },

    //exibeTicketsDoGrupo(grupo) {
    exibeTicketsDoGrupo(id) {
      this.tipoExibicao = 'teGrupo';
      this.grupoExibicao = id;
      this.listaParams = `estagio[in]=etCriacao,etAberto&grupo_id=${id}`;
      this.listaTickets();
    },

    exibeTicketsAbertos() {
      this.tipoExibicao = 'teAbertos';
      this.grupoExibicao = 0;
      this.listaParams = `estagio[in]=etCriacao,etAberto`;
      this.listaTickets();
    },

    exibeTicketsAguardando() {
      this.tipoExibicao = 'teAguardando';
      this.grupoExibicao = 0;
      this.listaParams = `estagio[in]=etCriacao,etAberto`;
      this.listaTickets();
    },

    exibeTicketsAtrasados() {
      const agora = this.dateTimeToMySQLDateTimeStr(new Date());
      this.tipoExibicao = 'teAtrasados';
      this.grupoExibicao = 0;
      this.listaParams = `estagio[in]=etCriacao,etAberto&previsao[lt]=${agora}`;
      this.listaTickets();
    },

    exibeTicketsEncerrados() {
      this.tipoExibicao = 'teEncerrados';
      this.grupoExibicao = 0;
      this.listaParams = `estagio=etEncerrado&arquivado=false`;
      this.listaTickets();
    },

    exibeHistoricoTickets() {
      this.tipoExibicao = 'teHistorico';
      this.grupoExibicao = 0;
      this.listaParams = `estagio=etEncerrado&arquivado=true`;
      this.listaTickets();
    },

    atualizaContadores() {
      api.get(`/helpdesk/contadores`).then(res => {
        this.contadores = res.data;
      }).catch(() => {
        //TODO: REFAZER EM TEMPO ESPECIFICO
      });
    },

    contadorGrupo(id) {
      const contador = this.contadores.grupos.find(x => x.grupo_id === id);
      if (!contador) {
        return 0;
      }

      return contador.tickets;
    },

    listaTickets() {
      this.carregaTickets();
    },

    visualizaTicket(ticket) {
      this.$router.push({ path: `/helpdesk/tickets/${ticket.id}/ver` });
    },

    formataAberto(ticket) {
      if (!ticket) {
        return '-';
      }

      const agora = new Date();
      const createdAt = new Date(ticket.created_at);
      const diffTime = Math.abs(agora - createdAt);
      const diffSegundos = Math.floor(diffTime / (1000));
      const diffMinutos = Math.floor(diffTime / (1000 * 60));
      const diffHoras = Math.floor(diffTime / (1000 * 60 * 60));
      const diffDias = Math.floor(diffTime / (1000 * 60 * 60 * 24));

      if (diffDias > 0) {
        return diffDias +'d';
      }
      if (diffHoras > 0) {
        return diffHoras +'h';
      }
      if (diffMinutos > 0) {
        return diffMinutos +'m';
      }
      return diffSegundos +'s';
    },

    nomeOperador(id) {
      if (!id) {
        return '';
      }

      const op = this.listaOperadores.find(x => x.id === id);

      if (!op) {
        return '';
      }

      return op.nome;
    },

    nomeCliente(id) {
      const cliente = this.clientes.find(x => x.id === id);

      if (!cliente) {
        return '';
      }

      return `${cliente.razao_social}`;
    },

    classeGrupoSelecionado(tipoExibicao, id) {
      if (this.tipoExibicao === tipoExibicao && this.grupoExibicao === id) {
        return ['menu-selecionado'];
      }

      return [];
    },

    ////////////////////////////////////////
    //modal-novo-ticket
    modalNovoTicketReset() {
      this.modalNovoTicket.form.identificacao = '';
      this.modalNovoTicket.form.contato = '';
      this.modalNovoTicket.form.descricaoCurta = '';
    },

    modalNovoTicketAbre() {
      document.getElementById('btn-modal-novo-ticket-abre').click();
    },

    modalNovoTicketFecha() {
      document.getElementById('btn-modal-novo-ticket-fecha').click();
    },

    modalNovoTicketAbreHandle() {
      this.modalNovoTicketReset();
      this.modalNovoTicketAbre();
    },

    modalNovoTicketPodeSalvar() {
      switch (true) {
        case (this.modalNovoTicket.form.identificacao.length < 3):
        case (this.modalNovoTicket.form.contato.length < 5):
        case (this.modalNovoTicket.form.descricaoCurta.length < 5):
          return false;

        default:
          return true;
      }
    },

    modalNovoTicketCadastrarHandle() {
      const form = this.modalNovoTicket.form;

      const sendData = {
        identificacao: form.identificacao,
        contato: form.contato,
        descricao_curta: form.descricaoCurta,
      };

      loading(true);

      api.post('/helpdesk/tickets', sendData).then((res) => {
        loading(false);
        this.modalNovoTicketFecha();
        // this.carregaTickets();
        this.$router.push({ path: `/helpdesk/tickets/${res.data.id}/editar` });
      }).catch(error => {
        loading(false);
        dialogo.erroHttp(error);
      });
    },

    modalNovoTicketRemoverHandle(ticket) {
      dialogo.confirmacao(`Confirma remover o ticket <b>#${ticket.id}</b>?`).then(() => {
        loading(true);

        api.delete(`/helpdesk/tickets/${ticket.id}`).then(() => {
          loading(false);
          this.carregaTickets();
        }).catch(error => {
          loading(false);
          dialogo.erroHttp(error);
        });
      });
    },
    //modal-novo-ticket
    ////////////////////////////////////////
  },

  created() {
    this.carregaMeuID();
    this.carregaGrupos();
    this.carregaOperadores();
    // this.carregaTickets();
    this.exibeMeusTickets();
    this.atualizaContadores();
    this.intervaloContadores = setInterval(this.atualizaContadores, 10000);
  },
  destroyed() {
    clearInterval(this.intervaloContadores);
  },
}
</script>

<style scoped>
.tabela-tickets .item-ticket:hover {
  background-color:rgba(128, 128, 128, 0.1);
}

.lista-grupos .item-grupo:hover {
  background-color:rgba(128, 128, 128, 0.1);
}

.menu-selecionado {
  font-weight: bold;
  color: rgb(16, 82, 182) !important;
  background-color:rgba(16, 82, 182, 0.13);
}

.table-sm-pc .badge {
  font-size: 11px;
}
</style>